// @ts-ignore
const SUPABASE_URL_ENV = process.env.REACT_APP_SUPABASE_URL || '';
// @ts-ignore
const SUPABASE_ANON_KEY_ENV = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const SUPABASE_URL = SUPABASE_URL_ENV || 'https://wjfpadwmaippmdrnreuf.supabase.co';
export const SUPABASE_ANON_KEY = SUPABASE_ANON_KEY_ENV;

if (typeof window !== 'undefined') {
}

export const STORAGE_KEYS = {
  session: 'sb:session',
};

export const IPC_CHANNELS = {
  storageGet: 'auth:storage:get',
  storageSet: 'auth:storage:set',
  storageRemove: 'auth:storage:remove',
  storageClear: 'auth:storage:clear',
  oauthComplete: 'auth:oauth-complete',
  getTokens: 'auth:getTokens',
};


